export default {
  namespaced: true,

  state: {
    type: sessionStorage.getItem("type") || "",
    projectName: sessionStorage.getItem("projectName") || "",
    objectName: sessionStorage.getItem("objectName") || "",
    serialNumber: sessionStorage.getItem("serialNumber") || "",
  },

  mutations: {
    setType(state, newValue) {
      state.type = newValue;
      sessionStorage.setItem("type", newValue);
    },
    setProjectName(state, newValue) {
      state.projectName = newValue;
      sessionStorage.setItem("projectName", newValue);
    },
    setObjectName(state, newValue) {
      state.objectName = newValue;
      sessionStorage.setItem("objectName", newValue);
    },
    setSerialNumber(state, newValue) {
      state.serialNumber = newValue;
      sessionStorage.setItem("serialNumber", newValue);
    },
  },

  actions: {
    updateType({ commit }, newValue) {
      commit("setType", newValue);
    },
    updateProjectName({ commit }, newValue) {
      commit("setProjectName", newValue);
    },
    updateObjectName({ commit }, newValue) {
      commit("setObjectName", newValue);
    },
    updateSerialNumber({ commit }, newValue) {
      commit("setSerialNumber", newValue);
    },
  },
};
